<template>
	<div class="content__column content__column--small">
		<h1 class="content__title">Lista de órdenes</h1>
		<div class="results" v-if="orders">
			<div class="results__element" v-for="(order, index) in orders" :key="index">
				<div class="results__info">
					<h2 class="results__title">Id de Orden: {{ order.id }}</h2>
					<p class="results__text" v-if="order.user_id">Id de usuario: {{ order.user_id }}</p>
					<p class="results__text" v-if="order.date_created">Creada el: {{ order.date_created | longDate('es-MX') }}</p>
					<p class="results__text">Tipo de usuario: {{ isNaN(order.user_id) ? 'Usuario no registrado' : 'Cliente registrado' }}</p>
				</div>
				<div class="results__actions">
					<button @click.prevent="$parent.$emit('view', order.id)" class="btn btn__icon btn__icon--regular results__btn results__btn--view">
						Ver Orden
					</button>
					<!-- TODO: BORRAR ITEMS Y DEVOLVER INVENTARIO ANTES DE BORRAR -->
					<button @click.prevent="deleteOrder(order.id)" class="btn btn__icon btn__icon--regular results__btn results__btn--delete">
						Borrar Orden
					</button>
				</div>
			</div>
		</div>
		<div class="information" v-else>
			<p class="information__text">No se encontraron resultados</p>
		</div>
		<confirmation v-if="confirm" @cancel="confirm = false"></confirmation>
	</div>
</template>

<script>
import httpService from '@/core/api/request'
import confirmation from '@/components/layout/confirmation'
export default {
	props: {
		filters: {
			type: String,
			required: false,
			default: function() {
				return ''
			}
		}
	},
	mixins: [httpService],
	components: { confirmation },
	data: function() {
		return {
			orderId: null,
			orders: null,
			confirm: false
		}
	},
	created: function() {
		this.getOrders()
	},
	mounted: function() {
		this.$on('continue', () => {
			this.confirm = false
			this.proccedToDelete()
		})
	},
	watch: {
		filters: function() {
			this.getOrders()
		},
		'$store.state.elementChanged': {
			handler: function() {
				this.getOrders()
			},
			deep: true
		}
	},
	methods: {
		getOrders: function() {
			let httpRequest = {
				params: '?' + this.filters + '&sort=-date_created',
				module: 'orders'
			}
			this.get(httpRequest)
				.then(orders => {
					this.orders = orders.data
				})
				.catch(() => {
					this.orders = null
				})
		},
		deleteOrder: function(id) {
			this.confirm = true
			this.orderId = id
		},
		proccedToDelete: function() {
			let httpRequest = {
				params: '',
				module: 'orders'
			}
			this.delete(this.orderId, httpRequest)
				.then(response => {
					this.getOrders()
					this.$store.commit('notificate', {
						title: 'ORDEN BORRADA',
						text: 'La orden ha sido borrada correctamente',
						type: 'success'
					})
				})
				.catch(error => {
					this.$store.commit('notificate', {
						title: 'ORDEN NO BORRADA',
						text: 'No se pudo borrar la orden seleccionada, por favor intente más tarde',
						type: 'warn'
					})
				})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/orders/list.vue